
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-inspirasi",
      function () {
        return require("private-next-pages/video-inspirasi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-inspirasi"])
      });
    }
  